<div class="welcome-modal-container">
  <div class="welcome-icon-container">
    <span class="welcome-icon">🎨</span>
  </div>

  <h1 mat-dialog-title class="welcome-title">
    {{ t.WelcomeModalTitle }}
  </h1>

  <mat-dialog-content class="welcome-content">
    <p class="welcome-subtitle">{{ t.WelcomeModalSubtitle }}</p>

    <div class="tutorial-steps">
      <div class="tutorial-step">
        <div class="step-number">1</div>
        <div class="step-content">
          <div class="step-title">{{ t.WelcomeStep1Title }}</div>
          <div class="step-description">{{ t.WelcomeStep1Description }}</div>
        </div>
      </div>

      <div class="tutorial-step">
        <div class="step-number">2</div>
        <div class="step-content">
          <div class="step-title">{{ t.WelcomeStep2Title }}</div>
          <div class="step-description">{{ t.WelcomeStep2Description }}</div>
        </div>
      </div>

      <div class="tutorial-step">
        <div class="step-number">3</div>
        <div class="step-content">
          <div class="step-title">{{ t.WelcomeStep3Title }}</div>
          <div class="step-description">{{ t.WelcomeStep3Description }}</div>
        </div>
      </div>
    </div>

    <div class="tutorial-note">
      <mat-icon style="color: #2196f3; margin-right: 8px;">info</mat-icon>
      <span>{{ t.WelcomeGuidanceNote }}</span>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="welcome-actions">
    <button mat-raised-button color="primary" (click)="onStartTutorial()" class="start-button" cdkFocusInitial>
      {{ t.WelcomeShowMeHow }}
    </button>
    <button mat-button (click)="onSkip()" class="skip-button">
      {{ t.WelcomeExploreOwn }}
    </button>
  </mat-dialog-actions>
</div>
